<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <div class="modal">
        <section class="modal-body">
          <div name="body" v-html="modalText">
          </div>
        </section>
        <section class="buttons">
          <button class="button-default" @click="ok">ok</button>
          <button class="button-default" v-if="showCancel" @click="close">annuleren</button>
        </section>
      </div>
    </div>
  </transition>
</template>

<script>

const BUTTONS = Object.freeze({
  OK: "Ok",
  OK_CANCEL: "OkCancel",
});

export default {
  name: "Modal",
  props:{ 
    modalText: String,
    showButtons: String
  },
  data: function () {
    return {
      message: this.$route.params.text
    }
  },
  computed: {
    showCancel: function() {
      return (this.showButtons === BUTTONS.OK_CANCEL);
    }
  },
  emits: [ 'cancel', 'ok' ],
  methods: {
    close() {
      this.$emit('cancel');
    },
    ok() {
      this.$emit('ok');
    },
  }
};
</script>

<style scoped>

.new {
  color: white;
}

/* mobile */
@media screen and (max-width: 600px) {
  button {
    margin: 3vw;
  }
}

/* ipad */
@media screen and (min-width: 601px) and (max-width: 1280px) {
  button {
    margin: 2vw;
  }
}

/* laptop */
@media screen and (min-width: 1281px) {
  button {
    margin: 1vw;
  }
}
</style>
